import { Card, Skeleton } from "antd";

const PageSkeleton = () => {
  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 6 }} />
      </Card>
    </div>
  );
};

export default PageSkeleton;
